import { isDestroyed, isDestroying } from '@ember/destroyable';
import { concat } from '@ember/helper';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import { task } from 'ember-concurrency';
import { t } from 'ember-intl';
import { formatUrl } from 'lumen/utils/rates-request';
import { timeout } from 'lumen/utils/waiters';

// @ts-expect-error: Incorrect type
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function subscriptionToOption(subscription) {
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    label: `${subscription.name} ${subscription.brand_code}`,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    subscription,
  };
}

interface ParityParityManagerIssueDetailHotelInMarketSearchSignature {
  Args: {
    selectItem: unknown;
  };
}

export default class ParityParityManagerIssueDetailHotelInMarketSearch extends Component<ParityParityManagerIssueDetailHotelInMarketSearchSignature> {
  @service declare ajax: Services['ajax'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare pmRequestService: Services['pm-request-service'];

  @tracked isOpen = false;
  @tracked options = [];
  @tracked optionsFilter = '';
  @tracked page = 0;

  fetchOptionsTask = task({ restartable: true }, async () => {
    // @ts-expect-error: Incorrect type
    let options = [];

    try {
      const path = '/api/v3/autocomplete/hotelsinmarket/';
      const params = {
        market_id: this.hotelAndMarketService.market?.id,
        q: this.optionsFilter,
      };

      const urlAutocomplete = formatUrl(path, params, this.ajax.host);

      const hotelsInMarket =
        await this.pmRequestService.requestData(urlAutocomplete);
      options = [
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...options,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        ...hotelsInMarket.results.map(subscriptionToOption),
      ];
    } catch (error) {
      this.pmRequestService.handleRequestError(error);
    } finally {
      // @ts-expect-error: Incorrect type
      this.isLoading = false;
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return options;
  });

  searchOptionTask = task({ restartable: true }, async (optionsFilter) => {
    await timeout();

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.optionsFilter = optionsFilter;
    this.page = 0;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.options = await this.fetchOptionsTask.perform();
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get value() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const subscription = this.args.selectedOption;

    if (!subscription) {
      return null;
    }

    return subscriptionToOption(subscription);
  }

  resetValues(): void {
    this.optionsFilter = '';
    this.page = 0;
    this.options = [];
  }

  @action
  // @ts-expect-error: Incorrect type
  selectOption(option): void {
    this.optionsFilter = '';
    // @ts-expect-error: Incorrect type
    this.args.selectItem(option);
  }

  @action
  toggleDropdown(): void {
    if (isDestroyed(this) || isDestroying(this)) {
      return;
    }

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      void this.searchOptionTask.perform(this.optionsFilter);
    } else {
      this.resetValues();
    }
  }

  <template>
    <div class="flex flex-col">
      <PrismComboSelectInput
        @isSearchable={{true}}
        @isSecondary={{true}}
        @loadingMessage={{concat (t "general.loading") "..."}}
        @onChange={{this.selectOption}}
        @onClose={{this.toggleDropdown}}
        @onOpen={{this.toggleDropdown}}
        @onSearch={{this.searchOptionTask.perform}}
        @options={{this.options}}
        @placeholder={{t "rates.hotelname"}}
        @searchMessage={{t "general.autocomplete.type_to_search"}}
        @unsafe_matchTriggerWidth={{true}}
        @value={{this.value}}
      />
    </div>
  </template>
}
